<ht-modal #modal [options]="modalOptions" (closeModalOutput)="onGotIt()">
  <p>Finish your ongoing call to perform this action.</p>
</ht-modal>
